import React, { useState, useEffect } from "react";
import { View, Image, Text, TouchableOpacity } from "react-native";
import { useNavigation, useIsFocused } from "@react-navigation/core";
import { formatGPXBalance } from "../../utils/formatNumber";
import styles from "./style";
import api from "../../services/api";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { FormattedMessage } from "react-intl";
import ScreenLoader from "../../components/ScreenLoader";

const TokenReleases = ({ loading }) => {
  const navigation = useNavigation();
  const [actives, setActives] = useState([]);
  const [clientCountry, setClientCountry] = useState(null);
  const [loadingData, setLoadingData] = useState(true);
  const [lang, setLang] = useState("");
  const [translatedNames, setTranslatedNames] = useState({});

  const loadActives = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoadingData(true);
    loading(true);

    try {
      const response = await api.get("/actives/actives-filtered", {
        headers: { Authorization: `Bearer ${token}` },
      });

      const filteredActives = response.data[0].filter((active) => {
        const isNotAdoption = active.adoption !== true;

        const isNotSustentavel = !active.category_name.includes("Sustentável");

        return isNotAdoption && isNotSustentavel;
      });

      setActives(filteredActives);
    } catch (error) {
      console.error("Error loading actives:", error);
    } finally {
      setLoadingData(false);
      loading(false);
    }
  };

  const fetchCountry = async () => {
    const country = await AsyncStorage.getItem("client_country");
    setClientCountry(country);
  };

  const getLang = async () => {
    const lang = await AsyncStorage.getItem("lang");
    setLang(lang);
    return lang;
  };

  const translate = async (text, lang) => {
    if (text.includes("USE")) return text;
    if (lang !== "it" && lang !== "en") return text;

    try {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      const response = await api.post(
        `/language-translation`,
        { text, target_language: lang },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response?.data?.translation || text;
    } catch (error) {
      console.error("Error translating text", error);
      return text;
    }
  };

  useEffect(() => {
    fetchCountry();
    getLang();
  }, []);

  useEffect(() => {
    const loadActivesWithDelay = async () => {
      if (clientCountry) {
        // Atrasar a chamada para loadActives
        await new Promise((resolve) => setTimeout(resolve, 1000)); // 1 segundo de atraso
        loadActives();
      }
    };
    loadActivesWithDelay();
  }, [clientCountry]);

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused && clientCountry) {
      loadActives();
    }
  }, [isFocused, clientCountry]);

  useEffect(() => {
    const translateNames = async () => {
      const newTranslatedNames = {};
      for (const active of actives) {
        const translatedName =
          clientCountry === "italia" || lang === "it" || lang === "en"
            ? await translate(active.name_token, lang)
            : active.name_token;
        newTranslatedNames[active.id] = translatedName;
      }
      setTranslatedNames(newTranslatedNames);
    };

    if (actives.length > 0) {
      translateNames();
    }
  }, [actives, clientCountry, lang]);

  const selectedToken = async (id, categoryName) => {
    await AsyncStorage.setItem("id_coin", id + "");
    navigation.navigate("MoreInfosCoin", { id, categoryName });
  };

  if (loadingData) {
    return <ScreenLoader loading={true} />;
  }

  return actives.map((item, i) => (
    <View key={i} style={styles.contentItem}>
      <View style={styles.textsItem}>
        <View style={styles.infoAtivoContainer}>
          <Image
            source={{
              uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}`,
            }}
            style={styles.img}
          />
          <View style={{ flexWrap: "wrap" }}>
            <Text style={styles.titleCoin}>
              {translatedNames[item.id] || item.name_token}
            </Text>
            <Text style={styles.priceCoin} numberOfLines={1}>
              <FormattedMessage id="tokensrelease.gpx" />
              {formatGPXBalance(item.single_value)}
            </Text>
          </View>
        </View>
        <View style={styles.tokenBtnsContainer}>
          <TouchableOpacity
            onPress={() =>
              navigation.navigate("Purchase", {
                viewType: "buy",
                selectedActive: item.id,
              })
            }
            style={styles.btnComprar}
          >
            <Text style={styles.btnComprarText}>
              <FormattedMessage id="tokenReleases.btnComprar" />
            </Text>
          </TouchableOpacity>

          <TouchableOpacity
            style={styles.btnSaibaMais}
            onPress={() => selectedToken(item.id, item.category_name)}
          >
            <Text style={styles.btnSaibaMaisText}>
              <FormattedMessage id="tokenReleases.btnSaibaMais" />
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  ));
};

export default TokenReleases;
